// Poll pacing for stale-while-revalidate responses (Constellations).
//
// The backend serves a stale clustering instantly with refreshing=true while
// a background recompute runs; the page then re-fetches until the fresh view
// arrives. Bounded so a refresh that keeps failing upstream cannot poll
// forever.

export function nextRefreshPollDelay(opts: {
  refreshing: boolean;
  loading: boolean;
  pollsSoFar: number;
  maxPolls: number;
  intervalMs: number;
}): number | null {
  const { refreshing, loading, pollsSoFar, maxPolls, intervalMs } = opts;
  if (!refreshing || loading) return null;
  if (pollsSoFar >= maxPolls) return null;
  return intervalMs;
}
